module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-top-backplates.4cd8b126.png";